/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useCallback, useEffect, useMemo, useRef, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import building from "assets/images/building.png";

import DataTable from "examples/Tables/DataTable";
import { Button, Card, CircularProgress, Icon, Menu, MenuItem, Switch } from "@mui/material";
import applicator from "ajv/dist/vocabularies/applicator";
import colors from "assets/theme/base/colors";
import { useNavigate } from "react-router-dom";
import NotificationItem from "examples/Items/NotificationItem";
import moment from "moment";
import { getAllCompanyList } from "api";
import debounce from "lodash.debounce";
import { updateCompanyProfile } from "api";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { getIndustries } from "api";
import { exportToExcel } from "utilities";
import { getCities } from "api";
import { getSponsors } from "api";

const Company = ({ name, location, industry, image }) => {
  const imgWidth = image ? "100%" : "50%";
  const imgHeight = image ? "100%" : "50%";
  const imgResize = image ? "cover" : "contain";
  return (
    <MDBox display="flex" gap={2}>
      <MDAvatar
        src={image || building}
        size="sm"
        sx={{
          width: "45px",
          height: "45px",
          border: "2px solid",
          borderColor: "success.main",
          "& img": {
            width: imgWidth,
            height: imgHeight,
            objectFit: imgResize,
            objectPosition: "center",
          },
        }}
      />
      <MDBox>
        <MDTypography
          display="block"
          variant="button"
          fontWeight="medium"
          noWrap
          sx={{
            maxWidth: "300px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </MDTypography>

        <MDTypography variant="caption">{location}</MDTypography>
        <MDBox>
          <MDTypography variant="caption" color="secondary" fontWeight="medium">
            {industry}
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  );
};

export default function data({}) {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [search, setSearch] = useState();
  const [loadingId, setLoadingId] = useState(null);

  const arrStatus = [
    { key: "all", name: "All" },
    { key: "active", name: "Active" },
    { key: "inactive", name: "Inactive" },
  ];
  const [status, setStatus] = useState(arrStatus[0]);

  const [arrIndustry, setArrIndustry] = useState([{ _id: "all", name: "All" }]);
  const [industry, setIndustry] = useState(arrIndustry[0]);

  const [arrLocation, setArrLocation] = useState([{ name: "All" }]);
  const [location, setLocation] = useState(arrLocation[0]);

  const [arrSponsor, setArrSponsor] = useState([{ _id: 0, name: "All" }]);
  const [sponsor, setSponsor] = useState(arrSponsor[0]);

  useEffect(() => {}, [loadingId]);

  useEffect(() => {
    onSearchData("");
    getIndustriesApi();
    getLocationApi();
    getSponsorsApi();
  }, []);

  useEffect(() => {
    if (search !== undefined) {
      getAllCompanyApi();
    }
  }, [search]);

  useEffect(() => {}, [status, industry]);

  const debouncedFetch = useRef(
    debounce((searchVal) => {
      setSearch(searchVal);
    }, 500)
  ).current;

  const getAllCompanyApi = (isReset = false) => {
    var params = {
      page: 1,
      limit: 10000,
      name: search,
    };

    if (isReset) {
      params.type = "all";
      params.industry = "all";
      params.location = "all";
      params.sponsor = "all";
    } else {
      params.type = status?.key || "all";
      params.industry = industry?._id || "all";
      params.location = location?.name || "all";
      params.sponsor = sponsor?._id || "all";
    }

    setLoading(true);

    getAllCompanyList({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setList(responseJson?.company);
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const getIndustriesApi = () => {
    var params = {
      page: 1,
      limit: 1000,
      type: "all",
    };

    getIndustries({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setArrIndustry([...arrIndustry, ...responseJson?.industry]);
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const getLocationApi = () => {
    var params = {
      page: 1,
      limit: 1000,
    };

    getCities({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setArrLocation([...arrLocation, ...responseJson?.cities]);
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const getSponsorsApi = () => {
    var params = {
      page: 1,
      limit: 1000,
    };

    getSponsors({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setArrSponsor([...arrSponsor, ...responseJson?.sponsors]);
          }
        }
      })
      .catch((e) => {});
  };

  const onSearchData = (val) => {
    debouncedFetch(val);
  };

  const handleAction = (item) => {
    navigate("/profile/company-detail", { state: { company: item } });
  };

  const columns = useMemo(() => {
    return [
      { Header: "name", accessor: "name", align: "left" },
      { Header: "registered on", accessor: "registered", align: "center" },
      {
        Header: "sponsors",
        accessor: "sponsors",
        align: "center",
      },
      {
        Header: "jobs",
        accessor: "jobs",
        align: "center",
      },
      {
        Header: "contacts",
        accessor: "contacts",
        align: "center",
      },
      {
        Header: "status",
        accessor: "status",
        align: "center",
      },
      {
        Header: "actions",
        accessor: "actions",
        align: "center",
      },
    ];
  }, []);

  const handleStatus = (item) => {
    setLoadingId(item?._id);
    var params = {
      isActive: item?.isActive ? false : true,
    };
    updateCompanyApi(params, item._id);

    // const updatedUsers = list.map((u) => (u._id === user.id ? { ...u, isActive: !u.isActive } : u));
    // setList(updatedUsers);
  };

  const handleJobs = useCallback(
    (item) => {
      navigate("/jobs/all-jobs", { state: { company: item } });
    },
    [navigate]
  );

  const handleContacts = useCallback(
    (item) => {
      navigate("/company/all-contacts", { state: { company: item } });
    },
    [navigate]
  );

  const getColor = (status) => {
    switch (status) {
      case "diamond":
        return "dark";
      case "platinum":
        return "light";
      case "gold":
        return "warning";
      case "silver":
        return "secondary";
      default:
        return "secondary";
    }
  };

  const rows = useMemo(() => {
    var rowsData = [];

    list.map((item) =>
      rowsData.push({
        name: (
          <Company
            name={item?.businessName}
            detail={`${item?.city}, ${item?.state}, ${item?.country}`}
            industry={item?.industry.map((item) => item?.name).join(", ")}
            location={item?.locations.map((item) => item).join(", ")}
            image={item?.businessImageURL}
          />
        ),
        registered: (
          <MDBox sx={{ px: 1 }}>
            <MDTypography variant="caption" noWrap>{`${moment(item?.createdAt).format(
              "DD MMM YYYY"
            )}`}</MDTypography>
          </MDBox>
        ),
        sponsors: (
          <MDBox sx={{ px: 1 }}>
            <MDBadge
              badgeContent={item?.sponsors?.name}
              color={getColor(item?.sponsors?.key)}
              variant="gradient"
              size="sm"
              circular
            />
          </MDBox>
        ),
        jobs: (
          <MDBox sx={{ px: 1 }} onClick={() => handleJobs(item)}>
            <MDTypography
              component="a"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{ cursor: "pointer" }}
            >
              <Icon fontSize="small">work</Icon>
            </MDTypography>
          </MDBox>
        ),
        contacts: (
          <MDBox sx={{ px: 1 }} onClick={() => handleContacts(item)}>
            <MDTypography
              component="a"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{ cursor: "pointer" }}
            >
              <Icon fontSize="small">people_alt</Icon>
            </MDTypography>
          </MDBox>
        ),
        status: (
          <MDBox sx={{ px: 1 }}>
            {loadingId === item?._id ? (
              <CircularProgress size={24} color="success" />
            ) : (
              <Switch
                checked={item?.isActive}
                onChange={() => handleStatus(item)}
                color="success"
              />
            )}
          </MDBox>
        ),
        actions: (
          <MDBox sx={{ px: 1 }} onClick={() => handleAction(item)}>
            <MDTypography
              component="a"
              variant="caption"
              color="secondary"
              fontWeight="medium"
              sx={{ cursor: "pointer" }}
            >
              <Icon fontSize="small">arrow_forward</Icon>
            </MDTypography>
          </MDBox>
        ),
      })
    );

    return rowsData;
  }, [list, Company, handleJobs, handleContacts]);

  const updateCompanyApi = (params, id) => {
    updateCompanyProfile({
      params: params,
      id: id,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            getAllCompanyApi();
          }
        }
      })
      .catch((e) => {})
      .finally(() => {
        setLoadingId(null);
      });
  };

  const handleApplyFilter = () => {
    getAllCompanyApi();
  };
  const handleResetFilter = () => {
    setStatus(arrStatus[0]);
    setIndustry(arrIndustry[0]);
    setLocation(arrLocation[0]);
    setSponsor(arrSponsor[0]);

    getAllCompanyApi(true);
  };

  const handleExport = () => {
    exportToExcel(list, "company.xlsx");
  };

  const ViewFilter = () => {
    return (
      <Card sx={{ mb: 3 }}>
        <MDBox
          p={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          flexWrap="wrap"
          gap={2}
        >
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Industry"
              value={JSON.stringify(industry)}
              onChange={(e) => setIndustry(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrIndustry.map((item) => (
                <MenuItem key={item?._id} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Location"
              value={JSON.stringify(location)}
              onChange={(e) => setLocation(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrLocation.map((item, index) => (
                <MenuItem key={index} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>

          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Sponsor"
              value={JSON.stringify(sponsor)}
              onChange={(e) => setSponsor(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 200,
                      maxWidth: 200,
                    },
                  },
                },
              }}
            >
              {arrSponsor.map((item, index) => (
                <MenuItem key={index} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>
          <MDBox sx={{ width: { xs: "100%", sm: "200px" } }}>
            <MDInput
              select
              label="Status"
              value={JSON.stringify(status)}
              onChange={(e) => setStatus(JSON.parse(e.target.value))}
              fullWidth
              InputProps={{ sx: { height: "44px" } }}
            >
              {arrStatus.map((item) => (
                <MenuItem key={item?.key} value={JSON.stringify(item)}>
                  {item?.name}
                </MenuItem>
              ))}
            </MDInput>
          </MDBox>
        </MDBox>
        <MDBox
          mb={3}
          ml={3}
          mr={3}
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          gap={2}
        >
          <MDBox display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={2}>
            <MDButton onClick={handleApplyFilter} color="success">
              apply
            </MDButton>
            <Button onClick={handleResetFilter} color="error" variant="contained">
              reset
            </Button>
          </MDBox>
          <MDButton onClick={handleExport} color="secondary" variant="contained">
            export
          </MDButton>
        </MDBox>
      </Card>
    );
  };

  return (
    <MDBox>
      <ViewFilter />
      <Card>
        <MDBox p={3} sx={{ width: "100%", overflowX: "auto" }}>
          <DataTable
            table={{ columns, rows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={true}
            canSearch={true}
            noEndBorder
            onSearch={(val) => {
              onSearchData(val);
            }}
          />
          {loading && (
            <MDBox display="flex" justifyContent="center" mt={2}>
              <CircularProgress size={24} color="success" />
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
